import React from 'react';
import { motion } from 'framer-motion';

const FollowupsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="p-6"
      >
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Follow-ups</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">Follow-up management coming soon...</p>
        </div>
      </motion.div>
    </div>
  );
};

export default FollowupsPage;